#!/usr/bin/env node
/**
 * Easy Email Pro MCP Server CLI 入口
 *
 * 使用方式：
 * npx easy-email-pro-mcp
 * 或
 * node dist/mcp/cli.js
 */

import { startMcpServer } from "./server";

startMcpServer().catch((error) => {
  console.error("Failed to start MCP server:", error);
  process.exit(1);
});
